import React, { useEffect, useRef, useState } from "react";
import "../../assets/styles/header.css";
import { ChevronDown, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuthContext();
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  // Close the dropdown on outside click.
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/signin", { replace: true });
  };

  return (
    <header className="header">
      <div></div>

      <div className="header-right">
        <div className="user-menu" ref={menuRef}>
          <div className="user-menu-trigger" onClick={() => setOpen((o) => !o)}>
            <img src="https://i.pravatar.cc/30" alt="user" className="avatar" />
            <ChevronDown className="menu-icon" />
          </div>

          {open && (
            <div className="user-dropdown">
              <div className="user-dropdown-head">
                <strong>{user?.fname || "Account"}</strong>
                <small>{user?.email}</small>
              </div>
              <button className="user-dropdown-item" onClick={handleLogout}>
                <LogOut size={16} />
                <span>Log out</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
